import __request__ from "routing/request";
export function triggerSync(authServiceId, requestOptions) {
  return __request__("POST", `/plugins/org.graylog.plugins.security/team-sync/trigger/${authServiceId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
